// @flow

import * as React from 'react';
import { MemberStatsBasic, MemberName } from '@ta/social.member-common';
import { MemberBio } from '@ta/social.member';
import { Link } from '@ta/common.routing';
import FollowButton from '@ta/social.follow';
import type { MemberProfile } from '@ta/social.member-types';
import { Avatar } from '@ta/styleguide.avatar';
import { ResponsiveImage } from '@ta/media.image';
import { InteractionLogger } from '@ta/tracking.interactions';

import styles from './FolloweeCardDetailed.less';

type Props = {
  member: MemberProfile,
};

const FolloweeCard = ({ member }: Props) => (
  <InteractionLogger>
    {logUserClick => (
      <Link
        href={member?.route?.url}
        onClick={e => logUserClick(e, 'userClick', { userId: member.userId })}
      >
        <div className={styles.candidate} key={member.displayName}>
          <div className={styles.cover_photo}>
            {member.coverPhoto &&
              member.coverPhoto.photoSizes &&
              member.coverPhoto.photoSizes.length > 0 && (
                <ResponsiveImage
                  sources={member.coverPhoto.photoSizes}
                  width="100%"
                  height="100px"
                />
              )}
          </div>
          <div className={styles.avatar_and_follow}>
            <div className={styles.avatar_container}>
              {member.avatar && member.avatar.photoSizes && member.avatar.photoSizes.length > 1 && (
                <Avatar
                  size="large"
                  withBorder
                  photo={member.avatar}
                  onClick={e => logUserClick(e, 'userClick', { userId: member.userId })}
                />
              )}
            </div>
            <div className={styles.follow_container}>
              <FollowButton
                profile={member}
                displayType="button+icon"
                size="small"
                preventClickPropagation
              />
            </div>
          </div>
          <div className={styles.member_info}>
            <MemberName
              profile={member}
              displayNameClassName={styles.display_name}
              addProfileLink={false}
              singleLine
            />
            <div className={styles.member_stats_container}>
              <MemberStatsBasic profile={member} />
            </div>
            <MemberBio className={styles.bio} truncateLength={80} bio={member.bio} smallText />
          </div>
        </div>
      </Link>
    )}
  </InteractionLogger>
);

/** The Detailed Followee Card component */
export default React.memo<Props>(FolloweeCard);
